import {Getter} from './types'
export default {
    [Getter.IsLoggedIn](state) {
        return state.loggedIn
    },
}
